import { i18nEn } from './en'
import { i18nKo } from './ko'

export default {
  en: i18nEn,
  ko: i18nKo
}
